// extracted by mini-css-extract-plugin
export default {"expand_option":"Expand_expand_option__KY7Qr","text":"Expand_text__0rs6W","container":"Expand_container__gJXfe"};